"use client";
import { useState } from "react";
import products from "./data/products.json";
import { motion } from "framer-motion";
import {
  Phone, Mail, Home, ArrowRight
} from "lucide-react";

export default function VisionHomePage() {
  const [sent, setSent] = useState(false);
  const [adviceSent, setAdviceSent] = useState(false);
  const [loanSent, setLoanSent] = useState(false);

  // 🧠 Poradenství
  const handleAdviceSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const html = `
      <h2>🧠 Poptávka poradenství (VisionHome)</h2>
      <p><strong>Jméno a příjmení:</strong> ${data.get("name")}</p>
      <p><strong>E-mail:</strong> ${data.get("email")}</p>
      <p><strong>Telefon:</strong> ${data.get("phone")}</p>
      <p><strong>Zpráva:</strong><br/>${(data.get("message") || "")
        .toString()
        .replace(/\n/g, "<br/>")}</p>
    `;

    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "Poradenství – nová poptávka",
          html,
          from: data.get("email"),
        }),
      });

      if (res.ok) {
        setAdviceSent(true);
        form.reset();
      } else {
        throw new Error("Chyba při odesílání");
      }
    } catch {
      alert("❌ Nepodařilo se odeslat. Zkuste to prosím znovu.");
    }
  };

  // 💶 Financování
  const handleLoanSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const html = `
      <h2>💶 Financování – poptávka</h2>
      <p><strong>Jméno:</strong> ${data.get("name")}</p>
      <p><strong>E-mail:</strong> ${data.get("email")}</p>
      <p><strong>Telefon:</strong> ${data.get("phone")}</p>
      <p><strong>Zpráva:</strong><br/>${(data.get("message") || "")
        .toString()
        .replace(/\n/g, "<br/>")}</p>
    `;

    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "Financování – nová poptávka",
          html,
          from: data.get("email"),
        }),
      });

      if (res.ok) {
        setLoanSent(true);
        form.reset();
      } else {
        throw new Error("Chyba při odesílání");
      }
    } catch {
      alert("❌ Nepodařilo se odeslat. Zkuste to prosím znovu.");
    }
  };

  // 📩 Kontakt
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const html = `
      <h2>📩 Kontakt – zpráva z webu</h2>
      <p><strong>Jméno:</strong> ${data.get("name")}</p>
      <p><strong>E-mail:</strong> ${data.get("email")}</p>
      <p><strong>Telefon:</strong> ${data.get("phone")}</p>
      <p><strong>Text zprávy:</strong><br/>${(data.get("message") || "")
        .toString()
        .replace(/\n/g, "<br/>")}</p>
    `;

    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "Kontakt – zpráva z VisionHome",
          html,
          from: data.get("email"),
        }),
      });

      if (res.ok) {
        setSent(true);
        form.reset();
      } else {
        throw new Error("Chyba při odesílání");
      }
    } catch {
      alert("❌ Nepodařilo se odeslat. Zkuste to prosím znovu.");
    }
  };

  // 🏡 Reality
  const handleRealtySubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const html = `
      <h2>🏡 Reality – poptávka nebo nabídka</h2>
      <p><strong>Jméno a příjmení:</strong> ${data.get("name")}</p>
      <p><strong>E-mail:</strong> ${data.get("email")}</p>
      <p><strong>Telefon:</strong> ${data.get("phone")}</p>
      <p><strong>Popis nemovitosti / zpráva:</strong><br/>${(data.get("message") || "")
        .toString()
        .replace(/\n/g, "<br/>")}</p>
    `;

    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "Reality – nová poptávka nebo nabídka",
          html,
          from: data.get("email"),
        }),
      });

      if (res.ok) {
        setSent(true);
        form.reset();
      } else {
        throw new Error("Chyba při odesílání");
      }
    } catch {
      alert("❌ Nepodařilo se odeslat. Zkuste to prosím znovu.");
    }
  };

  return (

    <div className="min-h-screen bg-gradient-to-b from-[#0B0B0B] via-[#101100] to-[#111] text-white scroll-smooth">
      {/* Top accent */}
      <div className="w-full h-1 bg-[#C6FF00]" />

      {/* Header */}
      <header className="sticky top-0 z-40 backdrop-blur bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="#home" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-[#C6FF00] grid place-items-center ring-1 ring-black/10">
              <Home className="w-5 h-5 text-black" />
            </div>
            <div>
              <div className="text-lg font-bold tracking-tight">VisionHome</div>
              <div className="text-xs text-white/60 -mt-0.5">Materiály • Poradenství • Finance • Reality</div>
            </div>
          </a>
          <nav className="hidden md:flex items-center gap-6 text-sm">
            <a href="#about" className="hover:text-[#C6FF00]">O nás</a>
            <a href="#advice" className="hover:text-[#C6FF00]">Poradenství</a>
            <a href="#shop" className="hover:text-[#C6FF00]">E-shop</a>
            <a href="#finance" className="hover:text-[#C6FF00]">Financování</a>
            <a href="#realestate" className="hover:text-[#C6FF00]">Reality</a>
            <a href="#contact" className="hover:text-[#C6FF00]">Kontakt</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section id="home" className="relative py-24 md:py-32 text-center overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(198,255,0,0.12)_0%,_transparent_70%)]" />
        <div className="relative max-w-3xl mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-5 leading-tight">
            Stavíme s vizí budoucnosti.
            <span className="block text-[#C6FF00]">VisionHome</span>
          </h1>
          <p className="text-white/80 text-lg mb-8">
            Komplexní servis pro fasády, zateplení, dotace, financování i realitní služby – na jednom místě.
          </p>
          <a href="#advice" className="px-6 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold inline-flex items-center gap-2 hover:brightness-95">
            Začít konzultaci <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>

      {/* O nás */}
      <section id="about" className="py-20 border-t border-white/10">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Kdo jsme a proč <span className="text-[#C6FF00]">VisionHome</span></h2>
          <p className="text-white/80 text-lg leading-relaxed">
            Jsme <span className="text-[#C6FF00] font-semibold">VisionHome</span> – váš partner pro{" "}
            <span className="text-[#C6FF00] font-semibold">stavební poradenství</span>,{" "}
            <span className="text-[#C6FF00] font-semibold">projektové řízení</span> a{" "}
            <span className="text-[#C6FF00] font-semibold">reality</span>. Pomáháme klientům vybrat{" "}
            <span className="text-[#C6FF00] font-semibold">vhodnou stavební či projekční firmu</span> a{" "}
            zajišťujeme <span className="text-[#C6FF00] font-semibold">bezpečný nákup</span> díky{" "}
            <span className="text-[#C6FF00] font-semibold">profesionální kontrole stavu nemovitosti</span>.  
            Každý projekt vedeme s důrazem na{" "}
            <span className="text-[#C6FF00] font-semibold">kvalitu</span>,{" "}
            <span className="text-[#C6FF00] font-semibold">preciznost</span> a{" "}
            <span className="text-[#C6FF00] font-semibold">maximální přehlednost</span>.
          </p>

          <p className="text-white/80 text-lg leading-relaxed mt-5">
            Součástí našich služeb je i dodávka{" "}
            <span className="text-[#C6FF00] font-semibold">profesionálních stavebních materiálů</span> pro vaši
            nemovitost – ať už jde o{" "}
            <span className="text-[#C6FF00] font-semibold">exteriér</span> nebo{" "}
            <span className="text-[#C6FF00] font-semibold">interiér</span>. Spolupracujeme výhradně s{" "}
            <span className="text-[#C6FF00] font-semibold">prověřenými výrobci</span> a dbáme na{" "}
            <span className="text-[#C6FF00] font-semibold">spolehlivé dodávky</span> i dlouhodobou kvalitu.
          </p>
        </div>
      </section>

      {/* Stavební poradenství */}
      <section id="advice" className="py-20 border-t border-white/10 bg-gradient-to-b from-[#0B0B0B] via-[#121200] to-[#141414]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center">Stavební poradenství</h2>
          <p className="text-white/80 text-center max-w-3xl mx-auto mb-12">
            Vyberte si balíček podle vašich potřeb – od technické konzultace po komplexní analýzu projektu.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Poradenství pro rodinné domy",
                price: "5 000 Kč",
                desc: "Zhodnocení stavu, dotace, doporučení technologií, návrh postupu realizace a její dohlížení. Včetně doporučení realizačních a projekčních společností.",
              },
              {
                title: "Poradenství pro bytové domy / SVJ",
                price: "10 000 Kč",
                desc: "Komplexní technická analýza, rozpočet, dotace a koordinace projektu. Doporučení prověřených realizačních a projekčních společností.",
              },
              {
                title: "Předkupní kontrola nemovitosti",
                price: "3 500 Kč",
                desc: "Prověření stavu před koupí. Při vyjednání slevy účtujeme od 10-30 % z dosažené částky. Deatilnější inforamce ohledně prohlídky zodpovíme telefonicky.",
              },
            ].map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="rounded-2xl border border-[#C6FF00]/30 bg-black/40 p-6 shadow-lg hover:border-[#C6FF00]/60 transition"
              >
                <h3 className="text-2xl font-semibold mb-2">{p.title}</h3>
                <div className="text-[#C6FF00] font-bold text-lg mb-3">{p.price}</div>
                <p className="text-white/80 mb-5">{p.desc}</p>
                <a href="#advice-form" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95">
                  Poptat balíček <ArrowRight className="w-4 h-4" />
                </a>
              </motion.div>
            ))}
          </div>

          {/* Formulář – poradenství */}
<div
  id="advice-form"
  className="mt-16 max-w-3xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8"
>
  <h3 className="text-2xl font-semibold mb-6 text-center">
    Nezávazná konzultace
  </h3>

  {!adviceSent ? (
    <form onSubmit={handleAdviceSubmit} className="grid md:grid-cols-2 gap-4">
      <input
        name="name"
        required
        placeholder="Jméno a příjmení"
        className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
      />
      <input
        name="email"
        required
        type="email"
        placeholder="E-mail"
        className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
      />
      <input
        name="phone"
        required
        placeholder="Telefon"
        className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
      />
      <textarea
        name="message"
        rows={4}
        placeholder="Popište vaši stavbu nebo záměr"
        className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
      />
      <div className="flex items-center gap-2 md:col-span-2 text-sm text-white/60">
        <input type="checkbox" required className="accent-[#C6FF00]" />
        <span>Souhlasím se zpracováním osobních údajů (GDPR)</span>
      </div>
      <button
        type="submit"
        className="mt-2 px-5 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95 md:col-span-2"
      >
        Odeslat poptávku <ArrowRight className="w-4 h-4 inline" />
      </button>
    </form>
  ) : (
    <div className="text-center text-[#C6FF00] font-semibold">
      Děkujeme! Ozveme se během 1 pracovního dne.
    </div>
  )}
</div>

        </div>
      </section>
      {/* E-shop */}
      {/* E-shop */}
{/* 🏗️ E-shop stavebnin – hlavní stránka */}
<section id="shop" className="py-20 border-t border-white/10">
  <div className="max-w-7xl mx-auto px-4 text-center">
    <h2 className="text-3xl md:text-4xl font-bold mb-6">
      🏗️ E-shop stavebnin – pro váš dům i byt
    </h2>
    <p className="text-white/80 max-w-2xl mx-auto mb-10">
      Ideální pro každého, kdo potřebuje doplnit pár pytlů lepidla nebo plánuje menší i větší rekonstrukci.
      V našem e-shopu můžete porovnat ceny materiálů i kompletní cenové nabídky včetně práce.
     💰 Garantujeme vždy nižší cenu, a to bez kompromisu v kvalitě materiálu ani provedení. Doprava po celé ČR ZDARMA.
    </p>

    {/* 5 produktů z JSONu */}
    <div className="grid md:grid-cols-3 gap-8">
      {products.slice(0, 5).map((p, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="p-6 rounded-2xl border border-white/10 bg-white/5 hover:border-[#C6FF00]/50 transition"
        >
          <img
            src={p.image}
            alt={p.name}
            className="w-full h-40 object-contain mb-4"
          />
          <div className="text-xl font-semibold mb-2">{p.name}</div>
          <p className="text-white/70 text-sm mb-3">{p.package}</p>
          <div className="text-[#C6FF00] font-semibold text-lg mb-4">
            {p.unit_price_with_vat.toFixed(2)} Kč s DPH
          </div>
          <button
            onClick={() => (window.location.href = "/shop")}
            className="px-5 py-2 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95"
          >
            Poptat
          </button>
        </motion.div>
      ))}
    </div>

    {/* tlačítko přechodu na celý katalog */}
    <div className="mt-12">
      <a
        href="/shop"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95"
      >
        Zobrazit celý katalog
        <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  </div>
</section>



      {/* Financování */}
      <section id="finance" className="py-20 border-t border-white/10 bg-gradient-to-b from-[#101100] via-[#1A1200] to-[#0B0B0B]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center">Financování & Hypotéky</h2>
          <p className="text-white/80 text-center mb-12 max-w-3xl mx-auto">
            <span className="text-[#C6FF00] font-semibold">VisionHome Finance</span> nabízí kompletní servis financování rekonstrukcí, výstavby i nákupu nemovitostí.  
            Spolupracujeme s předními bankami v ČR a zajišťujeme <span className="text-[#C6FF00] font-semibold">nejvýhodnější sazby</span> i <span className="text-[#C6FF00] font-semibold">rychlé schválení</span>.
          </p>

          {/* Tabulka */}
          <div className="overflow-x-auto max-w-4xl mx-auto mb-10">
            <table className="w-full border border-white/10 rounded-2xl text-sm md:text-base">
              <thead className="bg-[#C6FF00]/10 text-[#C6FF00]">
                <tr>
                  <th className="py-3 px-4 text-left">Výše hypotéky (Kč)</th>
                  <th className="py-3 px-4 text-left">Orientační splátka (Kč)</th>
                  <th className="py-3 px-4 text-left">Doba úvěru (let)</th>
                  <th className="py-3 px-4 text-left">Telefon</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {amount:"2 000 000", payment:"12 000", years:"20", phone:"+420 720 599 022"},
                  {amount:"3 000 000", payment:"18 000", years:"25", phone:"+420 720 599 022"},
                  {amount:"5 000 000", payment:"27 000", years:"30", phone:"+420 720 599 022"},
                ].map((r,i)=>(
                  <tr key={i} className="border-t border-white/10 hover:bg-white/5">
                    <td className="py-3 px-4">{r.amount}</td>
                    <td className="py-3 px-4 text-[#FF7A00] font-semibold">{r.payment}</td>
                    <td className="py-3 px-4">{r.years}</td>
                    <td className="py-3 px-4">{r.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-center text-white/60 text-sm mt-2">
              * Orientační přehled splátek – konkrétní nabídku připravíme individuálně
            </div>
          </div>

          {/* Formulář */}
          <div className="max-w-3xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8">
            <h3 className="text-2xl font-semibold mb-6 text-center">Nezávazná poptávka financování</h3>
            {!loanSent ? (
              <form onSubmit={handleLoanSubmit} className="grid md:grid-cols-2 gap-4">
  <input
    name="name"
    required
    placeholder="Jméno a příjmení"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="email"
    required
    type="email"
    placeholder="E-mail"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="phone"
    required
    placeholder="Telefon"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
  />
  <textarea
    name="message"
    rows={3}
    placeholder="Zpráva nebo specifikace vašeho záměru"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
  />
  <div className="flex items-center gap-2 md:col-span-2 text-sm text-white/60">
    <input type="checkbox" required className="accent-[#C6FF00]" />
    <span>Souhlasím se zpracováním osobních údajů (GDPR)</span>
  </div>
  <button
    type="submit"
    className="mt-2 px-5 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95 md:col-span-2"
  >
    Odeslat žádost <ArrowRight className="w-4 h-4 inline" />
  </button>
</form>

            ) : (
              <div className="text-center text-[#C6FF00] font-semibold">
                Děkujeme! Naši finanční specialisté vás budou kontaktovat do 24 hodin.
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Reality */}
      <section id="realestate" className="py-20 border-t border-white/10 bg-[#0C0C0C]">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Reality – prodej & pronájem</h2>
          <p className="text-white/80 max-w-3xl mx-auto mb-10">
            Nabízíme kompletní realitní servis – od ocenění a marketingu až po právní služby.  
            Každý klient získává <span className="text-[#C6FF00] font-semibold">individuální přístup</span>,  
            <span className="text-[#C6FF00] font-semibold">transparentní komunikaci</span> a <span className="text-[#C6FF00] font-semibold">profesionální zastoupení</span>.
          </p>

          {/* Co můžete očekávat */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-14 text-left">
            {[
              {icon:"🤝", title:"Osobní přístup", text:"Každý klient má svého specialistu, který se věnuje výhradně jeho projektu."},
              {icon:"📸", title:"Profesionální prezentace", text:"Fotografie, videoprohlídky a marketing zvyšují atraktivitu vaší nemovitosti."},
              {icon:"📜", title:"Právní zajištění", text:"Kompletní právní servis a kontrola smluv zajišťují bezpečný převod."},
              {icon:"💼", title:"Vyjednání nejlepší ceny", text:"Zastupujeme vás při jednání s kupujícími pro maximální zisk."}
            ].map((f,i)=>(
              <motion.div key={i} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}}
                className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <div className="text-3xl mb-3">{f.icon}</div>
                <div className="font-semibold mb-1">{f.title}</div>
                <p className="text-white/70 text-sm">{f.text}</p>
              </motion.div>
            ))}
          </div>
          {/* Formulář – Reality */}
          {!sent ? (
            <form onSubmit={handleRealtySubmit} className="max-w-xl mx-auto grid gap-4">
  <input
    name="name"
    required
    placeholder="Jméno a příjmení"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="email"
    required
    type="email"
    placeholder="E-mail"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="phone"
    required
    placeholder="Telefon"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <textarea
    name="message"
    rows={4}
    placeholder="Popis nemovitosti nebo poptávka"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <div className="flex items-center gap-2 text-sm text-white/60">
    <input type="checkbox" required className="accent-[#C6FF00]" />
    <span>Souhlasím se zpracováním osobních údajů (GDPR)</span>
  </div>
  <button
    type="submit"
    className="px-5 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95"
  >
    Odeslat poptávku <ArrowRight className="w-4 h-4 inline" />
  </button>
</form>

          ) : (
            <div className="text-[#C6FF00] font-semibold mt-6">Děkujeme! Ozveme se co nejdříve.</div>
          )}
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 border-t border-white/10 bg-[#0E0E0E]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center">Často kladené dotazy</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[{
              q:"Dodáváte materiál po celé ČR?",
              a:"Ano, máme distribuční síť a dopravce po celé republice."
            },{
              q:"Zajistíte i dotace?",
              a:"Ano, pomáháme s NZÚ, IROP i OPŽP – od energetiky po vyúčtování."
            },{
              q:"Jak rychle mohu získat nabídku?",
              a:"Obvykle do 1 pracovního dne od vyplnění formuláře."
            },{
              q:"Spolupracujete i s firmami?",
              a:"Ano, nabízíme individuální podmínky pro developery, SVJ i stavební společnosti."
            }].map((f,i)=>(
              <motion.div key={i} initial={{opacity:0,y:16}} whileInView={{opacity:1,y:0}} viewport={{once:true}}
                className="rounded-2xl p-6 border border-white/10 bg-white/5">
                <div className="font-semibold">{f.q}</div>
                <p className="mt-2 text-white/80">{f.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Kontakt */}
      <section id="contact" className="py-24 border-t border-white/10 bg-gradient-to-b from-[#101100] via-[#0B0B0B] to-black">
        <div className="max-w-6xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Kontaktujte nás</h2>
            <p className="text-white/80 mb-8 max-w-md">
              Zajímá vás spolupráce, financování nebo materiály?  
              Napište nám – odpovíme obvykle do 1 pracovního dne.
            </p>
            <div className="space-y-3 text-white/80">
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#C6FF00]" /> +420 720 599 022
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#C6FF00]" /> info@visionhome.cz
              </div>
              <div className="flex items-center gap-3">
                <Home className="w-5 h-5 text-[#C6FF00]" /> Praha / Středočeský kraj / Celá Česká republika
              </div>
            </div>
          </div>

          {/* Formulář – Kontakt */}
          <div className="rounded-2xl bg-white/5 border border-white/10 p-8">
            {!sent ? (
              <form onSubmit={handleContactSubmit} className="grid md:grid-cols-2 gap-4">
  <input
    name="name"
    required
    placeholder="Jméno a příjmení"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="email"
    required
    type="email"
    placeholder="E-mail"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10"
  />
  <input
    name="phone"
    placeholder="Telefon"
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
  />
  <textarea
    name="message"
    rows={4}
    placeholder="Vaše zpráva..."
    className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2"
  />
  <div className="flex items-center gap-2 md:col-span-2 text-sm text-white/60">
    <input type="checkbox" required className="accent-[#C6FF00]" />
    <span>Souhlasím se zpracováním osobních údajů (GDPR)</span>
  </div>
  <button
    type="submit"
    className="mt-2 px-5 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95 md:col-span-2"
  >
    Odeslat zprávu <ArrowRight className="w-4 h-4 inline" />
  </button>
</form>

            ) : (
              <div className="text-center text-[#C6FF00] font-semibold">
                Děkujeme! Vaše zpráva byla úspěšně odeslána.
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-10 text-center text-white/70 text-sm bg-black/70">
  <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3">
    <div>© {new Date().getFullYear()} VisionHome. Všechna práva vyhrazena.</div>
    <div className="flex items-center gap-6">
      <a href="mailto:info@visionhome.cz" className="hover:text-[#C6FF00]">info@visionhome.cz</a>
      <span className="text-white/40">•</span>
      <a href="tel:+420720599022" className="hover:text-[#C6FF00]">+420 720 599 022</a>
      <span className="text-white/40">•</span>
      <a href="/ochrana-osobnich-udaju" className="hover:text-[#C6FF00]">
        Ochrana osobních údajů
      </a>
    </div>
  </div>
</footer>

    </div>
  );
}
function CompareOfferForm() {
  const [sent, setSent] = useState(false);

  return (
    <div className="mt-8 max-w-3xl mx-auto">
      {!sent ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
          className="grid md:grid-cols-2 gap-4 bg-black/30 border border-white/10 rounded-2xl p-6"
        >
          <input required placeholder="Jméno a příjmení" className="px-3 py-2 rounded-lg bg-black/40 border border-white/10" />
          <input required type="email" placeholder="E-mail" className="px-3 py-2 rounded-lg bg-black/40 border border-white/10" />
          <input required placeholder="Telefon" className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2" />
          <select required className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2">
            <option value="">Typ nabídky</option>
            <option value="material">Pouze materiál (firmy, 200 m²+)</option>
            <option value="material_prace">Materiál + práce (investor)</option>
          </select>
          <input type="file" accept=".pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.png" className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2" />
          <textarea rows={3} placeholder="Poznámka" className="px-3 py-2 rounded-lg bg-black/40 border border-white/10 md:col-span-2" />
          <div className="flex items-center gap-2 md:col-span-2 text-sm text-white/60">
            <input type="checkbox" required className="accent-[#C6FF00]" />
            <span>Souhlasím se zpracováním osobních údajů (GDPR)</span>
          </div>
          <button type="submit" className="mt-2 px-5 py-3 rounded-xl bg-[#C6FF00] text-black font-semibold hover:brightness-95 md:col-span-2">
            Odeslat nabídku ke srovnání
          </button>
        </form>
      ) : (
        <div className="text-center text-[#C6FF00] font-semibold">
          Děkujeme! Nabídku jsme obdrželi. Ozveme se do 1 pracovního dne.
        </div>
      )}
    </div>
  );
}
